var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptLongBlue32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_28255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_28255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "receipt_long",
    d: "M8.3 28C7.38332 28 6.60415 27.6792 5.96249 27.0375C5.32083 26.3959 5 25.6167 5 24.7V21H8.74001V4L10.536 5.8L12.332 4L14.128 5.8L15.924 4L17.72 5.8L19.52 4L21.32 5.8L23.12 4L24.92 5.8L26.72 4V24.7C26.72 25.6167 26.3992 26.3959 25.7575 27.0375C25.1159 27.6792 24.3367 28 23.42 28H8.3ZM23.42 26C23.8 26 24.1117 25.8784 24.355 25.635C24.5983 25.3917 24.72 25.08 24.72 24.7V7.19998H10.74V21H22.12V24.7C22.12 25.08 22.2417 25.3917 22.485 25.635C22.7283 25.8784 23.04 26 23.42 26ZM12.2 11.96V9.96001H19.4V11.96H12.2ZM12.2 15.84V13.84H19.4V15.84H12.2ZM22.06 11.96C21.7867 11.96 21.5517 11.8617 21.355 11.665C21.1583 11.4683 21.06 11.2333 21.06 10.96C21.06 10.6867 21.1583 10.4517 21.355 10.255C21.5517 10.0583 21.7867 9.96001 22.06 9.96001C22.3333 9.96001 22.5683 10.0583 22.765 10.255C22.9617 10.4517 23.06 10.6867 23.06 10.96C23.06 11.2333 22.9617 11.4683 22.765 11.665C22.5683 11.8617 22.3333 11.96 22.06 11.96ZM22.06 15.74C21.7867 15.74 21.5517 15.6417 21.355 15.445C21.1583 15.2483 21.06 15.0133 21.06 14.74C21.06 14.4667 21.1583 14.2317 21.355 14.035C21.5517 13.8383 21.7867 13.74 22.06 13.74C22.3333 13.74 22.5683 13.8383 22.765 14.035C22.9617 14.2317 23.06 14.4667 23.06 14.74C23.06 15.0133 22.9617 15.2483 22.765 15.445C22.5683 15.6417 22.3333 15.74 22.06 15.74ZM8.27999 26H20.12V23H6.99998V24.7C6.99998 25.08 7.12265 25.3917 7.36799 25.635C7.61333 25.8784 7.91733 26 8.27999 26Z",
    fill: "#054BC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptLongBlue32);
export default __webpack_public_path__ + "static/media/receipt_long_blue-32.aa7328ea449fedf87a7841a4602e5474.svg";
export { ForwardRef as ReactComponent };